module.exports = __webpack_public_path__ + "vue2.png?3a0d801db339ba464384b01daae924bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vue2.png
// module id = 37
// module chunks = 0